/** Demo data — replace with API responses when backend is ready. */

export const DASHBOARD_STATS = [
  { label: "OTs running", value: "4 / 6", icon: "bed", tone: "success" },
  { label: "Cases today", value: "27", icon: "check", tone: "primary" },
  { label: "Avg turnover", value: "22 min", icon: "clock", tone: "info" },
  { label: "Emergencies", value: "3", icon: "alert-triangle", tone: "danger" },
];

export const UPCOMING_CASES = [
  { time: "09:00", ot: "OT-1", patient: "Ramesh K. · 54M", procedure: "Lap Cholecystectomy", surgeon: "Dr. Mehra", status: "Ready" },
  { time: "09:45", ot: "OT-2", patient: "Sunita R. · 38F", procedure: "Thyroidectomy", surgeon: "Dr. Iyer", status: "PAC pending" },
  { time: "10:30", ot: "OT-3", patient: "Arjun S. · 12M", procedure: "T&A", surgeon: "Dr. Khan", status: "Ready" },
  { time: "11:15", ot: "OT-4", patient: "Meena P. · 67F", procedure: "THR (Right)", surgeon: "Dr. Verma", status: "Optimization" },
  { time: "13:00", ot: "OT-1", patient: "Vikas B. · 45M", procedure: "Inguinal Hernia", surgeon: "Dr. Mehra", status: "Ready" },
];

export const LIVE_CASES = [
  { ot: "OT-1", patient: "Ramesh K. · 54M", procedure: "Lap Cholecystectomy", surgeon: "Dr. Mehra", anaes: "Dr. Bose", phase: "Incision", elapsed: "42 min", swabs: "12 / 12", state: "running" },
  { ot: "OT-2", patient: "Sunita R. · 38F", procedure: "Thyroidectomy", surgeon: "Dr. Iyer", anaes: "Dr. Rao", phase: "Time-out", elapsed: "08 min", swabs: "—", state: "running" },
  { ot: "OT-3", patient: "Arjun S. · 12M", procedure: "T&A", surgeon: "Dr. Khan", anaes: "Dr. Bose", phase: "Closure", elapsed: "31 min", swabs: "8 / 8", state: "running" },
  { ot: "OT-4", patient: "Meena P. · 67F", procedure: "Appendectomy", surgeon: "Dr. Verma", anaes: "Dr. Rao", phase: "Recovery", elapsed: "01h 12m", swabs: "10 / 10", state: "recovery" },
];

export const CASE_PHASES = ["Sign-in", "Induction", "Time-out", "Incision", "Closure", "Recovery"];

export const THEATRES = ["OT-1", "OT-2", "OT-3", "OT-4"];
export const SCHEDULE_HOURS = ["08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00"];

export const SCHEDULE_SLOTS = [
  { ot: "OT-1", start: 1, span: 2, label: "Lap Cholecystectomy", surgeon: "Dr. Mehra", type: "elective" },
  { ot: "OT-1", start: 5, span: 2, label: "Inguinal Hernia", surgeon: "Dr. Mehra", type: "daycare" },
  { ot: "OT-2", start: 1, span: 3, label: "Thyroidectomy", surgeon: "Dr. Iyer", type: "elective" },
  { ot: "OT-2", start: 6, span: 2, label: "FNAC + Biopsy", surgeon: "Dr. Iyer", type: "daycare" },
  { ot: "OT-3", start: 2, span: 1, label: "T&A", surgeon: "Dr. Khan", type: "daycare" },
  { ot: "OT-3", start: 4, span: 2, label: "Septoplasty", surgeon: "Dr. Khan", type: "elective" },
  { ot: "OT-4", start: 0, span: 2, label: "Appendectomy", surgeon: "Dr. Verma", type: "emergency" },
  { ot: "OT-4", start: 3, span: 3, label: "THR (Right)", surgeon: "Dr. Verma", type: "elective" },
];

export const CHECKLIST_SECTIONS = [
  {
    title: "Sign-in",
    subtitle: "Before induction of anaesthesia",
    items: [
      "Patient identity, site, procedure and consent confirmed",
      "Site marked",
      "Anaesthesia safety check completed",
      "Pulse oximeter on patient and functioning",
      "Known allergies confirmed",
      "Difficult airway / aspiration risk assessed",
      "Risk of >500 ml blood loss assessed",
    ],
  },
  {
    title: "Time-out",
    subtitle: "Before skin incision",
    items: [
      "All team members introduced by name and role",
      "Surgeon, anaesthetist and nurse verbally confirm patient, site, procedure",
      "Critical or non-routine surgical steps reviewed",
      "Anticipated case duration confirmed",
      "Antibiotic prophylaxis given within last 60 min",
      "Essential imaging displayed",
    ],
  },
  {
    title: "Sign-out",
    subtitle: "Before patient leaves the OT",
    items: [
      "Name of procedure recorded",
      "Instrument, sponge and needle counts correct",
      "Specimen labelled including patient name",
      "Equipment problems addressed",
      "Key concerns for recovery and management reviewed",
    ],
  },
];
